import React from 'react';
import './welcome-screen-modal.css';
import { Heading } from '../../heading';
import Copy from '../../../copy/welcome';
import { Paragraph } from '../../paragraph';

const WelcomeScreenModal = () => {
    return (
        <>
            <header className="welcome-screen-modal__header">
                <Heading
                    headingType="h3"
                    colorScheme="dark"
                    align="center"
                    withSpacing={false}
                >
                    Congratulations, you're a <br /> Member of Parliament!
                </Heading>
            </header>
            <div className="welcome-screen-modal__content">
                <Paragraph colorScheme="dark" withSpacing={true}>
                    {Copy.content['first-paragraph']}
                </Paragraph>
                <Paragraph colorScheme="dark" withSpacing={true}>
                    {Copy.content['second-paragraph']}
                </Paragraph>
                <Paragraph colorScheme="dark" withSpacing={true}>
                    {Copy.content['third-paragraph']}
                </Paragraph>
                <Paragraph colorScheme="dark" withSpacing={true}>
                    {Copy.content['fourth-paragraph']}
                </Paragraph>
            </div>
        </>
    );
};

export { WelcomeScreenModal };
